import styled from '@mui/system/styled';
import ListItem from '@mui/material/ListItem';

export const LectureItem = styled(ListItem)(({ theme }) => ({
  position: 'relative',
  cursor: 'pointer',
  paddingLeft: 0
}));
